import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import clsx from "clsx";

export default function HospitalEmployee({ docNumber, issuedAt, owner }: DocumentData) {
  return (
    <div
      className={clsx(
        "w-[23.75rem] h-[30rem] flex flex-col p-[1.875rem] ",
        "text-15 text-[#163D2E] font-medium",
      )}
      style={{
        backgroundImage: "url(./svg/documents/city-hospital.webp)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="italic text-center text-dark-800 uppercase mt-[5.375rem]">
        Центральная городская больница
      </div>
      <div className="italic text-center text-14 uppercase">СОТРУДНИК</div>
      <div className="flex items-start gap-5 mt-7.5">
        <div className="relative shrink-0 bg-white">
          <img
            src={owner.photo}
            alt=""
            className="w-[6.25rem] h-[7.5rem] border border-[#163D2E] pointer-events-none"
          />
          <div
            className="absolute -top-[0.3rem] left-0 right-0  h-[0.625rem]"
            style={{
              backgroundImage: "url(./svg/documents/green-photo-border-g.svg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
            }}
          />
          <div
            className="absolute -top-[0.3rem] -left-[0.25rem] h-[6.25rem] w-[0.625rem]"
            style={{
              backgroundImage: "url(./svg/documents/green-photo-border-v.svg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
            }}
          />
        </div>
        <div className="flex flex-col gap-4">
          <div>
            <div className="text-dark-800 text-14 uppercase">
              {[owner.lastName, owner.firstName].join(" ")}
            </div>
            <div>Имя Фамилия</div>
          </div>
          <div>
            <div className="text-dark-800 text-14 uppercase">{owner.rankName}</div>
            <div>Должность</div>
          </div>
          <div>
            <div className="text-dark-800 text-14 uppercase">{issuedAt}</div>
            <div>Дата выдачи</div>
          </div>
        </div>
      </div>
      <div className="w-[11.25rem] relative mt-11 border-b border-[#163D2E] text-right pb-2">
        Подпись
        {owner?.signature && (
          <div
            className="absolute z-2 h-[4rem] -bottom-[1rem] left-0"
            style={{
              backgroundImage: `url(${owner.signature})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        )}
        <img
          src="./svg/documents/seal-healthcare-service.webp" // TODO: {issuer.signature}
          alt=""
          className="absolute z-1 w-[6.25rem] aspect-square pointer-events-none -right-[8.25rem] -bottom-[3.1rem] rotate-12"
        />
      </div>
      <div className="w-full text-left text-dark-800 mt-auto">№ {docNumber}</div>
    </div>
  );
}
